module.exports = __webpack_public_path__ + "img/icon-drop-down-expand.2c3f5ba9.svg";